import React from 'react'
import TradePortal from '@/components/SHARED/trade-portal/trade-portal.component'

const ManageTradePortal = ({ gameData, gameElements }) => {
    return (
        <TradePortal
            isManager={true}
            gameData={gameData}
            gameElements={gameElements}
        />
    )
}

export default ManageTradePortal
